module.exports = __webpack_public_path__ + "static/media/as.480d167a.svg";